import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export class Loader {
   static $inject = ['$transitions'];

   constructor($transitions:uir.TransitionService) {
      $transitions.onStart({ }, (trans:uir.Transition) => {
         this.loading = true;
         trans.promise.then(() => this.loading = false);
      });
   }

   loading = false;
}

ng.module('selfReg')
   .service('loader', Loader);
